import React, { useState } from "react";
import { Dropdown, DropdownToggle,DropdownItem, DropdownMenu } from "reactstrap";

import OfferPaginator               from './Paginators/Offers';
import SurveyPaginator              from './Paginators/Surveys';
import CheckInPaginator             from './Paginators/CheckIn';
import ReferralPaginator            from './Paginators/Referrals';
import PromotionPaginator           from './Paginators/Promotions';
import BonusPaginator               from './Paginators/Bonus';
import TaskPaginator                from './Paginators/Tasks';
import GamePaginator                from './Paginators/Games';
import DragonHitTournamentPaginator from './Paginators/DragonHitTournament';
import ContestPaginator             from "./Paginators/Contests";
import TokensPaginator              from "./Paginators/Tokens";
import BetPaginator                 from "./Paginators/Bets";
import CashbacksPaginator           from "./Paginators/Cashbacks";
import GamesRecordsPaginator from "./Paginators/GamesRecords";

const HistoryTab = ()=> {

  const [toggleDrop , setToggleDrop] = useState(false);
  const [selected   , setSelected]   = useState('offers');

  return (
    <div className="history-tab">

      <Dropdown toggle={()=> setToggleDrop(!toggleDrop) } isOpen={toggleDrop} className="m-b-20 text-center">
        <DropdownToggle caret> Reward Categories </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={()=> setSelected('offers')}>  Offers {selected == 'offers' && <i className="fa fa-check m-l-10 text-info"></i>}  </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('surveys')}> Surveys {selected == 'surveys' && <i className="fa fa-check m-l-10 text-info"></i>}  </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('checkin')}> Check-In Bonus {selected == 'checkin' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('referrals') }> Referral Bonus {selected == 'referrals' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('telegram-promotions')}> Promotions & Giveaways {selected == 'telegram-promotions' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('bonus')}> Bonus {selected == 'bonus' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('task')}> Tasks {selected == 'task' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('games')}> Games {selected == 'games' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('dragonHitTournament')}> Games Tournament {selected == 'dragonHitTournament' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('gamesRecords')}> Games Records {selected == 'gamesRecords' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />


          <DropdownItem onClick={()=> setSelected('contests')}> Contests {selected == 'contests' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('tokens')}> Tokens {selected == 'tokens' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('bet')}> Jackpot {selected == 'bet' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

          <DropdownItem onClick={()=> setSelected('cashbacks')}> Cashbacks {selected == 'cashbacks' && <i className="fa fa-check m-l-10 text-info"></i>} </DropdownItem>
          <DropdownItem divider />

        </DropdownMenu>
      </Dropdown>

      { selected == 'offers'              &&  <OfferPaginator /> }
      { selected == 'surveys'             &&  <SurveyPaginator /> }
      { selected == 'checkin'             &&  <CheckInPaginator /> }
      { selected == 'referrals'           &&  <ReferralPaginator /> }
      { selected == 'dragonHitTournament' &&  <DragonHitTournamentPaginator /> }
      { selected == 'telegram-promotions' &&  <PromotionPaginator /> }
      { selected == 'bonus'               &&  <BonusPaginator /> }
      { selected == 'task'                &&  <TaskPaginator /> }
      { selected == 'games'               &&  <GamePaginator /> }
      { selected == 'contests'            &&  <ContestPaginator /> }
      { selected == 'tokens'              &&  <TokensPaginator /> }
      { selected == 'bet'                 &&  <BetPaginator /> }
      { selected == 'cashbacks'           &&  <CashbacksPaginator /> }
      { selected == 'gamesRecords'        &&  <GamesRecordsPaginator /> }
    </div>
  );
}

export default HistoryTab;
